import WriteContentBrief from '../../../src/components/content-ai-tools/WriteContentBrief';
import ToolsStyleWrapper from '../../../src/components/content-ai-tools/components/ToolsStyleWrapper';

const PublicDiscoveryKeywordsWrapped = () => {
  return <ToolsStyleWrapper component={WriteContentBrief} />;
};

export default PublicDiscoveryKeywordsWrapped;
